import { createSlice } from "@reduxjs/toolkit/"


let initialState = {
    currentUser: {telephone:"",prenom:"",nom:""},
    listUsers :[]
}
const usersSlice = createSlice({
    name:'navigation',
    initialState,
    reducers:{
        setCurrentUser:(state,{payload})=>{
            state.currentUser = payload
        },
        setUsersList:(state,{payload})=>{
            state.listUsers = payload
        },
        removeCurrentUser:(state,{payload})=>{
            state.currentUser = {}
        },
    }
})

export const { setCurrentUser,setUsersList,removeCurrentUser} = usersSlice.actions
export default usersSlice.reducer